import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';
import { splitByThousands } from '../../helpers/helper';

class PriceRow extends PureComponent {
  render() {
    const {
      price, name, noTitle, red, strike,
    } = this.props;
    if (price === undefined || price === 0) {
      return null;
    }
    const priceText = `${(name !== '基本料金' || red) && price > 0 ? '+' : ''}${splitByThousands(price)}円`;
    return (
      <Row>
        {!noTitle && (<Col>{name}</Col>)}
        <Col className={`text-right ${price < 0 ? 'discount' : ''} ${red ? 'red' : ''}`}>
          {strike ? <strike>{priceText}</strike> : priceText}
        </Col>
      </Row>
    );
  }
}

PriceRow.defaultProps = {
  price: 0,
  red: false,
  strike: false,
  noTitle: false,
};

PriceRow.propTypes = {
  price: PropTypes.number,
  name: PropTypes.string.isRequired,
  noTitle: PropTypes.bool,
  red: PropTypes.bool,
  strike: PropTypes.bool,
};

export default PriceRow;
